import React from 'react';
import { Button, Paper, Typography } from '@material-ui/core';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          padding: '24px 36px 39px',
        }}
      >
        <Paper
          elevation={0}
          style={{
            flex: 1,
            borderRadius: 22,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 32,
          }}
        >
          <Typography
            style={{
              color: '#41475a',
              fontWeight: 'bold',
              fontSize: 20,
              marginBottom: 8,
            }}
          >
            Ops!
          </Typography>
          <Typography
            style={{
              color: '#8e96b0',
              fontSize: 16,
              marginBottom: 24,
              textAlign: 'center',
            }}
          >
            Um erro ocorreu ao tentar carregar essa página.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleReload}
            style={{ textTransform: 'none', fontWeight: 'bold', boxShadow: 'none' }}
          >
            Recarregar
          </Button>
        </Paper>
      </div>
    );
  }
}

export default ErrorBoundary;
